<template>
  <div class="blog-detail-wrapper">

    <b-row class="blog-list-wrapper">
      <b-card no-body class="col-md-12">
        <b-card-header class="pb-50">
          <h5>
            Фильтр
          </h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col
                cols="12"
                md="6"
                class="mb-md-0 mb-2"
            >
              <label>Тип списков</label>
              <v-select
                  v-model="type"
                  :options="typeOptions"
                  class="w-100"
                  :reduce="val => val.value"
                  :clearable="false"
              />
            </b-col>
            <b-col
                cols="12"
                md="6"
                class="mb-md-0 mb-2 d-flex align-items-end"
            >
              <b-form-checkbox
                  v-model="includeAuto"
                  class="mt-2"
              >
                Включая АВТО
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-overlay
          :show="listLoading"
          rounded="sm"
      >
        <b-col cols="12" class="d-flex align-items-center justify-content-center mb-2 mb-md-0">
          <b-table
              :items="listsList"
              responsive
              :fields="tableColumns"
              primary-key="filmId"
              show-empty
              empty-text="No matching records found"
              class="position-relative w-100"
              style="table-layout: fixed;"
          >

            <!-- Column: List -->
            <template #cell(title)="data">
              <div class="d-flex align-items-center">
                <b-form-input
                    v-model="data.item.title"
                    class="flex-grow-1"
                />
                <b-button
                    v-if="isTitleChanged(data.item)"
                    variant="success"
                    class="btn-icon ml-1"
                    size="sm"
                    @click="saveTitle(data.item)"
                >
                  <feather-icon icon="CheckIcon"/>
                </b-button>
                <b-link v-if="!data.item.auto" class="ml-1" :to="{name: 'list-view', params: { id: data.item.id }}">
                  <feather-icon icon="ExternalLinkIcon"/>
                </b-link>
              </div>
            </template>

            <!-- Column: Subtype -->
            <template #cell(subtype)="data">
              <div class="d-flex align-items-center">
                <v-select
                    v-model="data.item.subtype"
                    :options="subtypeOptions"
                    :reduce="val => val.value"
                    class="flex-grow-1"
                    style="min-width: 200px"
                    :clearable="true"
                    placeholder="Выберите подтип"
                />
                <b-button
                    v-if="isSubtypeChanged(data.item)"
                    variant="success"
                    class="btn-icon ml-1"
                    size="sm"
                    @click="saveSubtype(data.item)"
                >
                  <feather-icon icon="CheckIcon"/>
                </b-button>
              </div>
            </template>

            <!-- Column: Actions -->
            <template #cell(actions)="data">
              <div class="text-nowrap">
                <b-button
                    variant="danger"
                    class="btn-icon"
                    size="sm"
                    @click="confirmDelete(data.item)"
                >
                  <feather-icon icon="TrashIcon"/>
                </b-button>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-overlay>
    </b-row>

    <b-overlay
        :show="createItemLoading"
        rounded="sm"
    >
      <b-row class="mb-1">
        <b-col cols="12">
          <b-form-input
              v-model="newListName"
              placeholder="Название списка"
          />
        </b-col>
        <b-col cols="12" class="mt-1">
          <b-button
              type="submit"
              variant="success"
              block
              @click.prevent="createItem(newListName)"
          >
            Добавить
          </b-button>
        </b-col>
      </b-row>
    </b-overlay>

    <!--/ blogs -->

    <!-- Modal Delete Confirmation -->
    <b-modal
        id="modal-delete"
        ref="deleteModal"
        title="Подтверждение удаления"
        ok-variant="danger"
        ok-title="Удалить"
        cancel-title="Отмена"
        centered
        @ok="deleteItem"
    >
      <p>Вы уверены, что хотите удалить список "{{ itemToDelete ? itemToDelete.title : '' }}"?</p>
    </b-modal>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BLink,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BCardHeader,
  BTable,
  BOverlay,
  BButton,
  BModal,
  BFormCheckbox,
  VBTooltip,
} from 'bootstrap-vue'
import {avatarText, badWord, kFormatter, truncateString} from '@core/utils/filter'
import store from "@/store";
import {onUnmounted, ref, watch} from "@vue/composition-api";
import topicsStoreModule from "@/views/topics/topicsStoreModule";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BCardHeader,
    BTable,
    BButton,
    BOverlay,
    BModal,
    BFormCheckbox,
    vSelect,
  },
  data() {
    return {
      blogSidebar: {},
      disabled: 0,
      newListName: '',
    }
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  methods: {},
  setup() {
    const STORE_MODULE_NAME = 'topics'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, topicsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    // Table Handlers
    const tableColumns = [
      {key: 'id', label: '#', sortable: false, thStyle: {width: '60px'}},
      {key: 'title', sortable: true, thStyle: {width: '30%'}},
      {key: 'subtype', label: 'Подтип', sortable: true, thStyle: {width: '350px'}},
      {key: 'items_count', sortable: true},
      {key: 'auto', sortable: true},
      {key: 'actions'},
    ]

    const type = ref('music')
    const includeAuto = ref(false)
    const typeOptions = [
      { label: 'Музыка', value: 'music' },
      { label: 'Фильмы', value: 'movies' },
      { label: 'Сериалы', value: 'series' },
    ]

    const subtypeOptions = [
      { label: 'Матрица (буквы подряд)', value: 'matrix_letters' },
      { label: 'Первая буква', value: 'first_letter' },
      { label: 'Страна', value: 'country' },
      { label: 'Матрица (инициалы)', value: 'matrix_initials' },
      { label: 'Матрица (начало/конец слова)', value: 'matrix_word_edges' },
      { label: 'Тематика', value: 'theme' },
      { label: 'Другие темы в названиях', value: 'other_naming_topics' },
      { label: 'Количество слов', value: 'word_count' },
      { label: 'Количество букв', value: 'letter_count' },
      { label: 'Жанры', value: 'genres' },
      { label: 'Символы в названии', value: 'symbols_in_title' },
      { label: 'Предлоги в названии', value: 'prepositions_in_title' },
      { label: 'Год выхода', value: 'release_year' },
      { label: 'Актеры', value: 'actors' },
      { label: 'Режиссеры', value: 'directors' },
      { label: 'Награды', value: 'awards' },
      { label: 'Студия', value: 'studio' },
      { label: 'Год начала деятельности', value: 'foundation_year' },
      { label: 'Год распада', value: 'dissolution_year' },
      { label: 'Год рождения', value: 'birth_year' },
      { label: 'Год смерти', value: 'death_year' },
    ]

    const originalSubtypes = ref({})
    const originalTitles = ref({})

    const listsList = ref([])
    const createItemLoading = ref(false)
    const listLoading = ref(false)
    const lists = ref([])
    const freeLists = ref([])
    const itemToDelete = ref(null)
    const deleteModal = ref(null)
    const fetchLists = (...args) => store.dispatch('topics/fetchLists', ...args)
    const addList = (...args) => store.dispatch('topics/createList', ...args)
    const removeList = (...args) => store.dispatch('topics/deleteList', ...args)
    const updateListAction = (...args) => store.dispatch('topics/updateList', ...args)

    const fetchListsList = () => {
      listLoading.value = true;
      const params = {type: type.value}
      if (!includeAuto.value) {
        params.auto = 0
      }
      fetchLists({queryParams: params})
          .then(response => {
            listsList.value = response.data.data
            lists.value = response.data.lists
            freeLists.value = response.data.free_lists
            // Сохраняем оригинальные значения subtype и title
            const subtypes = {}
            const titles = {}
            response.data.data.forEach(item => {
              subtypes[item.id] = item.subtype
              titles[item.id] = item.title
            })
            originalSubtypes.value = subtypes
            originalTitles.value = titles
            listLoading.value = false;
          })
    }

    const createItem = (name) => {
      createItemLoading.value = true
      addList({queryParams: {title: name, type: type.value}}).then(response => {
        listsList.value.push(response.data.data)
        createItemLoading.value = false
        this.newListName = ''
      })
    }

    const confirmDelete = (item) => {
      itemToDelete.value = item
      deleteModal.value.show()
    }

    const deleteItem = () => {
      if (!itemToDelete.value) return
      listLoading.value = true
      removeList({id: itemToDelete.value.id}).then(() => {
        listsList.value = listsList.value.filter(item => item.id !== itemToDelete.value.id)
        itemToDelete.value = null
        listLoading.value = false
      }).catch(() => {
        listLoading.value = false
      })
    }

    const isSubtypeChanged = (item) => {
      return item.subtype !== originalSubtypes.value[item.id]
    }

    const saveSubtype = (item) => {
      updateListAction({id: item.id, queryParams: {subtype: item.subtype}}).then(() => {
        originalSubtypes.value = {...originalSubtypes.value, [item.id]: item.subtype}
      })
    }

    const isTitleChanged = (item) => {
      return item.title !== originalTitles.value[item.id]
    }

    const saveTitle = (item) => {
      updateListAction({id: item.id, queryParams: {title: item.title}}).then(() => {
        originalTitles.value = {...originalTitles.value, [item.id]: item.title}
      })
    }

    fetchListsList()

    watch([type, includeAuto], () => {
      fetchListsList()
    }, {
      deep: true,
    })

    return {
      fetchLists,
      fetchListsList,
      tableColumns,
      listsList,
      lists,
      avatarText,
      createItem,
      createItemLoading,
      listLoading,

      typeOptions,
      type,
      includeAuto,

      itemToDelete,
      deleteModal,
      confirmDelete,
      deleteItem,

      subtypeOptions,
      isSubtypeChanged,
      saveSubtype,
      isTitleChanged,
      saveTitle,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
